import { makeStyles } from "@material-ui/styles"
import { CELL_HEIGHTS } from "@utils";

const useStyle = makeStyles(() => ({
  
  labelContainer: {
    height: CELL_HEIGHTS.XXLARGE * 4,
  },
  labelCell: {
    minHeight: CELL_HEIGHTS.XXLARGE,
    position: "relative",
    top: -46,
  }
}));

export default useStyle;